"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _css = require("@emotion/css");
var _hooks = require("../../../../hooks");
const useStyles = () => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  return {
    'cc-ModalFooterSection': (0, _css.css)({
      display: 'flex',
      alignItems: 'center',
      gap: pxToRem(10)
    })
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;